import React, { useEffect, useRef } from "react";
import { icons } from "../../assets/icons";
import { Link } from "react-router-dom";
// import InputWithIcon from "../FormFields/InputWithIcon";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import useApi from "../../hooks/useApi";
import NotificationSidebar from "../../NotificationSidebar/NotificationSidebar";
import { apiUrls } from "../../utils/api/apiUrls";
import { useClickAway } from "react-use";

const DashboardHeader = () => {
  // const location = useLocation();
  const { logout } = useAuth();
  const { apiCall: apiCall1 } = useApi();
  const [notificationCount, setNotificationCount] = useState(0);
  const [notificationIsOpen, setNotificationIsOpen] = useState(false);
  const dropdownRef = useRef();

  const { user, setUser } = useAuth();

  useEffect(() => {
    apiCall1({
      url: apiUrls.user.profile,
      method: "get",
      onSuccess: (data) => {
        setUser({ ...user, ...data });
      },
    });
  }, []);

  useEffect(() => {
    let notificationCall = setInterval(() => {
      notificationApiCall();
    }, 300 * 1000);
    return () => {
      clearInterval(notificationCall);
    };
  }, []);

  useClickAway(dropdownRef, () => {
    onClickClose();
  });

  const onClickClose = () => {
    setDropDownOpen(false);
  };

  const dropDownOptions = [
    { name: "Groups", icon: icons.groupIcon, link: "/groups" },
    { name: "Users", icon: icons.roleIcon, link: "/users" },
    // { na me: "Roles", icon: icons.roleIcon, link: "/roles" },
    // { name: "My Account", icon: icons.accountIcon, link: "/myaccount" },
    // { name: "Help Center", icon: icons.helpIcon2, link: "" },
    // { name: "Raise A Request", icon: icons.raiseIcon, link: "/raisearequest" },
    { name: "Sign Out", icon: icons.signoutIcon, onClick: () => logout() },
  ];

  const [dropDownOpen, setDropDownOpen] = useState(false);

  const renderLeft = () => {
    return (
      // <InputWithIcon
      //   placeholder="Search"
      //   containerClassName="!w-[48rem] !h-[5rem] !bg-[var(--whiteColor)] !px-[2rem] shadow-[0_0_6px_#00000029]"
      //   inputClassName="flex font-size-medium placeholder-[var(--lightGray)]"
      //   rightIcon={icons.searchIcon}
      // />
      <div></div>
    );
  };

  const { data: data2, apiCall: notificationCountApi } = useApi(false);

  const notificationApiCall = () => {
    notificationCountApi({
      url: apiUrls.sso.getNotificationCount,
      method: "get",
      onSuccess: (data) => {
        setNotificationCount(data);
      },
    });
  };

  const closeNotificationSidebar = () => {
    setNotificationIsOpen(false);
  };

  const notificationCountCss = {
    position: "absolute",
    top: "9px",
    right: "6px",
    border: "none",
    background: "red",
    borderRadius: "16px",
    width: "16px",
    height: "16px",
    textAlign: "center",
  };

  const { name = "", username = "", roleName = ""} = user || {};
  return (
    <div className="header-container">
      {renderLeft()}
      <div className="flex items-center gap-x-[2.6rem]">
        {/* <div className="relative">
          <img
            src={icons.bellIcon}
            alt="Notification Bell Icon"
            className="w-[4rem] h-[4rem] mt-2 cursor-pointer"
            onClick={() => {
              notificationApiCall(); // to update call count status
              setNotificationIsOpen(true);
            }}
          />
          {notificationCount > 0 && (
            <div style={notificationCountCss}>
              <span className="text-white font-semibold text-sm">
                {notificationCount || ""}
              </span>
            </div>
          )}
        </div> */}
        <div
          className={`px-5 relative ${
            dropDownOpen ? "shadow-[0_0_6px_#00000029] bg-[#fff]" : ""
          }`}
          ref={dropdownRef}
        >
          <div
            className="flex gap-x-[1.2rem] cursor-pointer py-2 select-none"
            onClick={() => setDropDownOpen(!dropDownOpen)}
          >
            <img
              src="https://picsum.photos/200/300"
              className="user-image"
              alt="user"
            />

            <div className="cursor-pointer flex">
              <div className="flex items-center text-end">
                <div className="font-size-medium font-family-medium text-[var(--blackColor)] mr-4 w-32">
                  { roleName || 'Kv Admin' }
                </div>
                <img
                  src={icons.arrowDown}
                  alt="arrow down"
                  className={`h-[0.9rem] w-[1.4rem] arrow ${
                    dropDownOpen ? "rotate" : ""
                  }`}
                />
              </div>
              <div className="font-size-small text-[var(--lightGray)] leading-[1.4rem]">
                {/* {username || 'Admin'} */}
              </div>
            </div>
          </div>
          <div
            className={`profile-dropdown min-h-[10rem] w-[100%] absolute z-50 bg-[var(--whiteColor)] left-0 font-size-small text-[var(--darkGray)] ${
              dropDownOpen ? "unhide-dropdown" : ""
            }`}
          >
            {dropDownOptions.map((item) => {
              if (item?.link) {
                return (
                  <Link
                    to={item.link}
                    className="flex items-center gap-x-4"
                    key={item.name}
                    onClick={onClickClose}
                  >
                    <img src={item.icon} alt={item.name} />
                    <div>{item.name}</div>
                  </Link>
                );
              } else {
                return (
                  <div
                    className="flex items-center gap-x-4"
                    key={item.name}
                    onClick={item.onClick}
                  >
                    <img src={item.icon} alt={item.name} />
                    <div>{item.name}</div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
      {notificationIsOpen && (
        <NotificationSidebar
          closeNotificationSidebar={closeNotificationSidebar}
        />
      )}
    </div>
  );
};

export default DashboardHeader;
